import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { ValidateFirstName } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Select, { SelectProps } from "@insite/mobius/Select";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField from "@insite/mobius/TextField/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    CallbackType,
    ErrorObjectType,
    InputObjectType,
    validate,
    ValidatorRuleType,
} from "@tCentro/Common/Utilities/validate";
import downloadLineCard from "@tCentro/Handlers/CENDownLoadLineCard";
import parse from "html-react-parser";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    downloadLineCard,
};

interface OfferingsModel {
    fields: {
        label: string;
    };
}
const enum fields {
    textField = "textField",
    title = "title",
    description = "description",
    offerings = "offerings",
    emailTo = "emailTo",
    image = "image",
    imageUrl = "imageUrl",
    formDescription = "formDescription",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.textField]: string;
        [fields.description]: string;
        [fields.offerings]: OfferingsModel[];
        [fields.emailTo]: string;
        [fields.title]: string;
        [fields.image]: string;
        [fields.imageUrl]: string;
        [fields.formDescription]: string;
    };
    extendedStyles?: LineCardStyles;
}

export interface LineCardStyles {
    nameGridItem?: GridItemProps;
    submitButton?: InjectableCss;
    buttonWrapper?: InjectableCss;
    descriptionStyle?: InjectableCss;
    checkboxStyle?: InjectableCss;
    mainGridContainerStyles: GridContainerProps;
    leftGridItemStyles: GridItemProps;
    rightGridItemStyles: GridItemProps;
    fullLengthGridItemStyles: GridItemProps;
    imageStyles?: ImgProps;
    messageTextArea: TextAreaProps;
    divisionSelectStyles: SelectProps;
}

export const lineCardStyles: LineCardStyles = {
    imageStyles: {
        css: css`
            max-width: 100%;
            height: auto;
        `,
    },
    divisionSelectStyles: {
        css: css``,
    },
    messageTextArea: {},
    mainGridContainerStyles: {
        css: css`
            margin-top: 56px;
            label {
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
                color: ${getProp("theme.typography.p.color")};
            }
            input {
                background: #f2f2f2 !important;
                border-radius: 40px !important;
                padding: 12px 24px !important;
                ::placeholder {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 24px;
                    color: ${getColor("text.main")};
                }
            }
            textarea {
                background: #f2f2f2 !important;
                border-radius: 40px !important;
                padding: 12px 24px !important ;
            }
            select {
                background: #f2f2f2 !important;
                border-radius: 40px !important;
            }
        `,
    },
    fullLengthGridItemStyles: {
        width: [12, 12, 12, 12, 12],
        css: css``,
    },
    leftGridItemStyles: {
        width: [12, 12, 12, 6, 6],
        css: css`
            @media (min-width: 992px) and (max-width: 1200px) {
                flex-basis: 100% !important;
                max-width: 100% !important;
            }
        `,
    },
    rightGridItemStyles: {
        width: [12, 12, 12, 6, 6],
        css: css`
            @media (min-width: 992px) and (max-width: 1200px) {
                flex-basis: 100% !important;
                max-width: 100% !important;
            }
        `,
    },
    nameGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            padding: 14px;
            margin-bottom: 14px !important;
            margin-top: 20px;
        `,
    },

    submitButton: {
        css: css`
            background: #276b40;
            color: #ffffff;
            padding: 16px 21px;
            font-size: 14px;
            font-weight: 500;
            width: 100%;
            height: 100%;
            border-radius: 40px;
            border: none;

            font-family: "Poppins";
            &:hover {
                background: #276b40;
            }
        `,
    },

    buttonWrapper: {
        css: css`
            margin-top: 32px;
            margin-bottom: 32px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 32px auto;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    descriptionStyle: {
        css: css`
            font-size: 16px;
            padding: 0px;
            font-weight: 500;
            font-family: "Poppins";
            color: black;
            margin-top: 5px;
        `,
    },

    checkboxStyle: {
        css: css`
            font-size: 16px;
            font-family: "Poppins";
            color: black;
            margin-bottom: 4px;
        `,
    },
};

const styles = lineCardStyles;

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export const intialErrorFormState = {
    name: "",
    email: "",
    companyName: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}
export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const downloadFormValidatorConfig: ValidatorConfigType = {
    name: {
        required: true,
        label: "Name",
        regexMsg: "Name is required.",
    },
    companyName: {
        required: true,
        label: "Company Name",
        regexMsg: "Company Name is required.",
    },
    email: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Email",
        regexMsg: "Please enter valid email.",
    },
};

export const CENLineCardForm: FC<Props> = ({ fields }) => {
    const history = useHistory();
    const [name, setName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [selectedOfferings, setSelectedOfferings] = useState<Record<string, string>>({});
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [selectedDivision, setSelectedDivision] = useState("");

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | any,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = downloadFormValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);
        const formErrs = { ...formErrors };
        if (isValidate === undefined) {
            delete formErrs[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrs);
        } else {
            formErrs[input.name] = isValidate ? isValidate.errorMsg : isValidate;
            setFormErrors(formErrs);
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrs[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrs);
        }

        setIsButtonDisabled(validateSubmitDisabled(formErrs));
    };

    const nameChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setName(input.value);
    };
    const firstNameHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setFirstName(input.value);
    };

    const lastNameHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setLastName(input.value);
    };

    const emailChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setEmail(input.value);
    };
    const companyNameChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setCompanyName(input.value);
    };

    const handleSelectOffering = (event: React.SyntheticEvent, value: boolean, label: string) => {
        if (value) {
            setSelectedOfferings({ ...selectedOfferings, [label]: label });
        } else {
            const offrs = { ...selectedOfferings };
            delete offrs[label];
            setSelectedOfferings(offrs);
        }
    };

    const selectChangeHandler = (input: HTMLSelectElement) => {
        setSelectedDivision(input.value);
    };

    const submitHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsButtonDisabled(true);
        const formHasErrors = validateSubmitDisabled(formErrors);
        if (formHasErrors) {
            return false;
        }
        const businessDivisions = Object.keys(selectedOfferings);
        downloadLineCard({
            name,
            email,
            companyName,
            emailTo: fields.emailTo,
            businessDivisions,
            uri: "",
            properties: {},
            onSuccess: () => {
                history.push("/LineCard");
            },
        });
    };

    return (
        <GridContainer {...styles.mainGridContainerStyles}>
            <GridItem {...styles.leftGridItemStyles}>
                <Img src={fields.imageUrl} loading="lazy" altText={fields.title} {...styles.imageStyles} />
            </GridItem>
            <GridItem {...styles.rightGridItemStyles}>
                <GridContainer>
                    <GridItem {...styles.nameGridItem}>
                        <TextField
                            label={translate("First Name")}
                            name="firstName"
                            value={firstName}
                            onChange={e => firstNameHandler(e.currentTarget)}
                            onBlur={e => validateHandler(e.currentTarget)}
                            error={!!formErrors.name && formErrors.name}
                            iconProps={{
                                color: "danger",
                                src: formErrors.name ? AlertTriangle : undefined,
                            }}
                            required
                            placeholder="First Name"
                        />
                    </GridItem>
                    <GridItem {...styles.nameGridItem}>
                        <TextField
                            label={translate("Last Name")}
                            name="lastName"
                            value={lastName}
                            onChange={e => lastNameHandler(e.currentTarget)}
                            onBlur={e => validateHandler(e.currentTarget)}
                            required
                            placeholder="Last Name"
                        />
                    </GridItem>
                    <GridItem {...styles.nameGridItem}>
                        <TextField
                            label={translate("Company Name")}
                            name="companyName"
                            value={companyName}
                            onChange={e => companyNameChangeHandler(e.currentTarget)}
                            onBlur={e => validateHandler(e.currentTarget)}
                            error={!!formErrors.companyName && formErrors.companyName}
                            iconProps={{
                                color: "danger",
                                src: formErrors.companyName ? AlertTriangle : undefined,
                            }}
                            required
                            placeholder="Company Name"
                        />
                    </GridItem>
                    <GridItem {...styles.nameGridItem}>
                        <TextField
                            label={translate("Email")}
                            placeholder="Company Email"
                            value={email}
                            onChange={e => emailChangeHandler(e.currentTarget)}
                            onBlur={e => validateHandler(e.currentTarget)}
                            error={!!formErrors.email && formErrors.email}
                            iconProps={{
                                color: "danger",
                                src: formErrors.email ? AlertTriangle : undefined,
                            }}
                            required
                        />
                    </GridItem>
                    <GridItem {...styles.fullLengthGridItemStyles}>
                        <TextField label={translate("Phone Number")} placeholder="Phone Number" />
                    </GridItem>
                    <GridItem {...styles.fullLengthGridItemStyles}>
                        <TextField label={translate("Zip Code")} required placeholder="Zip Code" />
                    </GridItem>
                    <GridItem {...styles.fullLengthGridItemStyles}>
                        {fields.offerings && fields.offerings.length > 0 ? (
                            <Select
                                label={translate("{0}", fields.description)}
                                {...styles.divisionSelectStyles}
                                value={selectedDivision}
                                onChange={e => selectChangeHandler(e.currentTarget)}
                            >
                                <option disabled={false} value="">
                                    {translate("Select a Division")}
                                </option>
                                {fields.offerings.map((offering, index) => (
                                    // eslint-disable-next-line react/jsx-key
                                    <option value={offering.fields.label}>{offering.fields.label}</option>
                                ))}
                            </Select>
                        ) : null}
                    </GridItem>
                    <GridItem {...styles.fullLengthGridItemStyles}>
                        <TextArea
                            label={translate("Message")}
                            {...styles.messageTextArea}
                            placeholder={translate("Type your message here")}
                        ></TextArea>
                    </GridItem>
                    <GridItem {...styles.fullLengthGridItemStyles}>
                        <Typography>{parse(transformContentHtml(fields.formDescription), parserOptions)}</Typography>
                    </GridItem>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button onClick={submitHandler} disabled={isButtonDisabled} {...styles.submitButton}>
                            {translate("Submit")}
                        </Button>
                    </StyledWrapper>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(CENLineCardForm),
    definition: {
        group: "Common",
        displayName: "Line Card Request Form",
        fieldDefinitions: [
            {
                name: fields.imageUrl,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Image",
            },
            {
                name: fields.description,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "Division",
                displayName: "Offerings List Title",
            },
            {
                name: fields.formDescription,
                fieldType: "General",
                editorTemplate: "RichTextField",
                defaultValue: "",
                displayName: "Line Card Info",
            },
            {
                name: fields.offerings,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.label;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "label",
                        displayName: "Label",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
            {
                name: fields.emailTo,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
                displayName: "Receiver Email Id",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
